import { render, staticRenderFns } from "./UploadHistory.vue?vue&type=template&id=781495d4"
import script from "./UploadHistory.vue?vue&type=script&lang=js"
export * from "./UploadHistory.vue?vue&type=script&lang=js"
import style0 from "./UploadHistory.vue?vue&type=style&index=0&id=781495d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports